var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "relative bg-cl-transparent brdr-none inline-flex",
      attrs: {
        type: "button",
        "data-testid": "openMicrocart",
        "aria-label": _vm.$t("Open microcart")
      },
      on: { click: _vm.openMicrocart }
    },
    [
      _c("i", { staticClass: "material-icons" }, [_vm._v("shopping_cart")]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass:
            "minicart-count absolute flex center-xs middle-xs border-box py0 px2 h6 lh16 weight-700 cl-white",
          class: _vm.totalQuantities ? "bg-cl-forest-green" : "bg-cl-black",
          attrs: { "data-testid": "minicartCount" }
        },
        [_vm._v("\n    " + _vm._s(_vm.totalQuantities) + "\n  ")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }